import { Column } from 'components/Layout/Grid';
import styled from 'styled-components';

interface IStyleProps {
  isRotateIcon: boolean;
};

export const SelectGlobal = styled(Column) `
  display: grid !important;
  grid-template-areas: "select";
  align-items: center;

  select {
    appearance: none;
    grid-area: select;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 0.9375rem;
    cursor: pointer;

    &::-ms-expand {
      display: none;
    }
  }

  &:after {
    content: "";
    width: 0.6em;
    height: 0.5em;
    margin-right: 10px;
    background-color: #BEBEBE;
    clip-path: polygon(100% 0, 0 0%, 50% 100%);
    grid-area: select;
    justify-self: end;
    pointer-events: none;

    transform: ${(props: IStyleProps) => props.isRotateIcon && "rotate(180deg)"};
    transition: all 0.5s ease;
  }

  &:before {
    content: "";
    margin-right: 0.1em;
    -webkit-clip-path: inset(0 0 0 0);
    clip-path: inset(0 0 0 0);
    grid-area: select;
    justify-self: end;
  }
`;